import React from 'react';
import { MuiThemeProvider } from 'material-ui/styles';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { Root } from './Root';
import { PrivacyPolicy } from './PrivacyPolicy';
import { Terms } from './Terms';
import { NotFound } from './NotFound';

import theme from '../lib/theme';
import { PATHS as paths } from '../lib/constants'

const App = () => (
  <MuiThemeProvider theme={theme}>
    <BrowserRouter>
      <Switch>
        <Route exact path={paths.root} component={Root} />
        <Route path={paths.privacy} component={PrivacyPolicy} />
        <Route path={paths.terms} component={Terms} />
        <Route component={NotFound} />
      </Switch>
    </BrowserRouter>
  </MuiThemeProvider>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx